import { useState } from "react";
import { testimonials } from "@/mocks/portfolio";
import FadeIn from "@/components/base/FadeIn";

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section id="testimonials" className="bg-background-100 py-24 md:py-36 border-t border-foreground-950/10">
      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-foreground-700 mb-5">
              ( Testimonials ) — Words from Patrons
            </p>
            <h2 className="font-display font-black text-foreground-950 leading-[0.88] tracking-[-0.04em] text-[12vw] md:text-[7vw] lg:text-[5.5vw]">
              The <em className="font-serif italic font-light">experience</em>,
              <br />
              in their <em className="font-serif italic font-light">words</em>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              onMouseEnter={() => setActive(i)}
              className={`group cursor-pointer p-6 md:p-8 border transition-all duration-500 ${
                active === i
                  ? "border-primary-500/40 bg-background-50"
                  : "border-foreground-950/10 bg-background-50/50"
              }`}
            >
              {/* Quote mark */}
              <div className="font-display text-5xl md:text-6xl text-accent-500/30 leading-none mb-6">&ldquo;</div>

              <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-serif mb-8 min-h-[120px]">
                {t.quote}
              </p>

              <div className="flex items-center gap-4 pt-6 border-t border-foreground-950/10">
                <FadeIn delay={i * 150}>
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 relative">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                    <div className="absolute inset-0 z-10 rounded-full ring-2 ring-accent-500/50 ring-offset-1 ring-offset-background-50" />
                  </div>
                </FadeIn>
                <div>
                  <p className="font-display text-sm uppercase tracking-[0.12em] text-foreground-950">{t.name}</p>
                  <p className="text-[11px] text-foreground-700 font-serif italic">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}